import guidelines from "../services/mechanics.guidelines";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        errors: null,
        guidelines: {
            title: "",
            description: "",
            image: ""
        }
    },
    mutations: {
        loading(state) {
            state.loading = true;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        guidelines(state, value) {
            state.guidelines.title = value.title;
            state.guidelines.description = value.description;
            state.guidelines.image = value.image;
        }
    },
    actions: {
        async getGuidelines({ commit, state }) {
            commit("loading");
            try {
                let response = await guidelines.getGuidelines();
                if (response.guideline != null) {
                    commit("guidelines", response.guideline);
                }
                state.loading = false;
                return response;
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async saveGuidelines({ commit, state }, param) {
            commit("loading");
            try {
                let response = await guidelines.saveGuidelines(param);
                commit("guidelines", response.guideline);
                state.loading = false;
                notification.success(response.message);
                return response;
            } catch (errors) {
                commit("errors", errors);
            }
        }
    }
};
